export enum CommunityType {
    PRIVATE = 'PRIVATE',
    PUBLIC = 'PUBLIC'
}